<ng-container *ngIf="!isWebView">
  <c-container [fluid]="true">
    <button (click)="toggleSidebar()" class="ps-1">
      <svg
        [cIcon]="icons.cilMenu"
        size="xl"
        title="Menu"
        style="color: black"
      ></svg>
    </button>

    <c-card-header class="header-section">
      <img
        src="assets/images/AIkoshblackLogo.svg"
        class="img-fluid umang-logo"
        alt="AIKosh Logo"
      />
    </c-card-header>

    <c-header-nav class="ms-3">
      <ng-container *ngTemplateOutlet="userDropdown"></ng-container>
    </c-header-nav>
  </c-container>
</ng-container>

<ng-template #userDropdown>
  <c-dropdown alignment="end" variant="nav-item">
    <button cButton cDropdownToggle class="py-0 avatar-btn">
      <c-avatar
        shape="rounded-1"
        size="md"
        (error)="onImageAvtrError($event)"
        [src]="
          loggedInUserInfo?.profile?.profilePic || 'assets/images/avatar.jpg'
        "
      ></c-avatar>
    </button>
    <div cDropdownMenu>
      <div class="profile-first-tab profile-divider">
        <c-avatar
          shape="rounded-1"
          size="md"
          (error)="onImageAvtrError($event)"
          [src]="
            loggedInUserInfo?.profile?.profilePic || 'assets/images/avatar.jpg'
          "
        ></c-avatar>
        <div class="profile-user-details">
          <div>
            {{ loggedInUserInfo?.fullname || "--" }}
          </div>
          <div>
            {{loggedInUserInfo?.roles?.[0]?.name || '--'}}
          </div>
        </div>
      </div>
      <div class="profile-redirect-tab profile-divider">
        <div (click)="myProfileRedirect()">
          <img src="assets/images/person_outline_black.svg" />
          My Profile
        </div>
        <div (click)="resetPassword()">
          <img src="assets/images/passwordChnage.svg" />
          Change Password
        </div>
      </div>
      <div class="profile-redirect-tab">
        <div class="logout" (click)="logoutBtnClicked()">
          <img src="assets/images/logoutIcon.svg" />
          Log out
        </div>
      </div>
    </div>
  </c-dropdown>
</ng-template>
